<template>
  <div class="hm-transfer coupon-transfer">
    <div class="flex item-center">
      <!-- 左边 -->
      <div
        class="transfer"
        :class="{
          divide:
            transferMode === 'bindGuider' ||
            transferMode === 'selectRule' ||
            transferMode === 'sendTarget'
        }"
      >
        <div class="flex transfer-header flex-center">
          <div class="select flex-2 text-center">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="isPreview || leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="leftName">{{ leftName }}</span>
          </div>
        </div>
        <div
          class="transfer-body"
          :class="{
            flex:
              transferMode !== 'bindGuider' &&
              transferMode !== 'selectRule' &&
              transferMode !== 'sendTarget'
          }"
        >
          <div class="divide-header" v-if="transferMode === 'bindGuider'">
            <!-- <span class="store" v-show="transferMode === 'bindGuider'">门店</span> -->
            <span class="guider">导购</span>
            <span class="guider-id">工号</span>
            <span class="activity">活动</span>
          </div>
          <div class="divide-header" v-if="transferMode === 'selectRule'">
            <span class="rule-name">规则名</span>
            <span class="use-target">使用对象1</span>
            <span class="use-target">标签</span>
          </div>
          <div class="divide-header" v-if="transferMode === 'sendTarget'">
            <span class="activity">门店</span>
            <span class="guider">导购</span>
            <span class="guider-id">工号</span>
          </div>
          <el-checkbox-group
            :disabled="isPreview"
            v-model="leftChecked"
            @change="handleLeftCheckedChange"
          >
            <div
              v-for="(v, i) in leftData"
              :key="i"
              class="check-wrapper flex item-center"
            >
              <div class="flex-2">
                <el-checkbox class="flex" :label="v">
                  <!-- <span class="store" v-show="transferMode === 'bindGuider'">{{v.storeOutletName}}</span> -->
                  <span class="flex-1" v-if="transferMode === 'sendTarget'">
                    {{ v.departName }}
                  </span>
                  <span>{{
                    v.name || v.realName || v.guiderName || v.realname
                  }}</span>
                  <span v-if="transferMode === 'sendTarget'">
                    {{ v.workNum }}
                  </span>
                  <span
                    class="guider-id"
                    v-if="transferMode === 'bindGuider'"
                    >{{ v.workNum }}</span
                  >
                  <span class="activity" v-if="transferMode === 'bindGuider'">
                    {{ v.sendName }}
                  </span>
                  <span v-if="transferMode === 'selectRule'">
                    {{
                      v.isPlus === 0
                        ? "PLUS会员"
                        : v.isPlus === 1
                        ? "全部会员"
                        : "全部会员"
                    }}
                  </span>
                  <span v-if="transferMode === 'selectRule'">
                    {{ v.labelName }}
                  </span>
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="flex flex-column control text-center">
        <div>操作</div>
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou"
          @click="allToRight"
          :disabled="leftData.length <= 0 || isPreview"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="
            leftData.length <= 0 || leftChecked.length <= 0 || isPreview
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou"
          @click="allToLeft"
          :disabled="rightData.length <= 0 || isPreview"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-mjiantou-copy"
          @click="toLeft"
          :disabled="
            rightData.length <= 0 || rightChecked.length <= 0 || isPreview
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-mjiantou-copy delete-selected"
          @click="deleteChecked"
          :disabled="
            leftChecked.length <= 0 || rightData.length <= 0 || isPreview
          "
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button>
      </div>
      <!-- 右边 -->
      <div class="transfer">
        <div
          class="flex transfer-header flex-center text-center"
          :class="background"
          style="padding: 1rem"
        >
          <div class="select flex-2" style="padding: 0">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="isPreview || rightData.length <= 0"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="rightName">{{ rightName }}</span>
          </div>
        </div>
        <div
          class="transfer-body flex flex-column"
          v-if="transferMode !== 'selectRule' && transferMode !== 'sendTarget'"
        >
          <el-checkbox-group
            :disabled="isPreview"
            v-model="rightChecked"
            @change="handleRightCheckedChange"
          >
            <div
              v-for="(v, i) in rightData"
              :key="i"
              class="check-wrapper flex"
            >
              <div class="flex-2">
                <el-checkbox :label="v">{{
                  v.name ||
                    v.realName ||
                    v.rule_name ||
                    v.guiderName ||
                    v.realname
                }}</el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </div>
        <div class="transfer-body" v-else>
          <div class="divide-header" v-if="transferMode === 'selectRule'">
            <div class="devide-type">
              <span class="coupon-type  flex-1">类型</span>
              <span class="coupon-name flex-1">券名</span>
              <span class="coupon-target  flex-1">使用对象2</span>
              <span class="coupon-target  flex-1">标签</span>
            </div>
            <div class="count">
              数量
              <el-tooltip
                class="tooltip"
                effect="light"
                placement="top"
                content="在自助领券类型下，限制单人领取最多张数，其他场景下限制每次发放的张数"
              >
                <i class="el-icon-question" style="font-size: 18px"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="divide-header" v-if="transferMode === 'sendTarget'">
            <span class="coupon-type">门店</span>
            <span class="coupon-name flex-1">导购</span>
            <span class="coupon-target">工号</span>
          </div>
          <el-checkbox-group
            :disabled="isPreview"
            v-model="rightChecked"
            @change="handleRightCheckedChange"
          >
            <template v-if="transferMode === 'selectRule'">
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper flex"
              >
                <el-checkbox :label="v" class="devide-body flex item-center" style="overflow: hidden;">
                  <span class="coupon-type flex-1">{{
                    v.type || v.departName
                  }}</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="
                      v.name ||
                        v.realName ||
                        v.rule_name ||
                        v.guiderName ||
                        v.realname
                    "
                    placement="top-end"
                  >
                    <span class="coupon-name flex-1">
                      {{
                        v.name ||
                          v.realName ||
                          v.rule_name ||
                          v.guiderName ||
                          v.realname
                      }}
                    </span>
                  </el-tooltip>
                  <span class="coupon-target flex-1">
                    {{
                      v.isPlus === 0
                        ? "PLUS会员"
                        : v.isPlus === 1
                        ? "全部会员"
                        : "全部会员"
                    }}
                  </span>
                  <!-- <span class="flex-1" v-if="transferMode === 'selectRule'">
                    {{ v.labelName }}
                  </span> -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="
                      v.labelName
                    "
                    placement="top-end"
                     v-if="transferMode === 'selectRule'"
                  >
                    <span class="coupon-name flex-1">
                      {{
                        v.labelName
                      }}
                    </span>
                  </el-tooltip>
                </el-checkbox>
                <div class="flex">
                  <div
                    class="minus"
                    @click="toMinus(i, v.num <= 1)"
                    v-show="!isPreview"
                    :class="{ disabled: v.num <= 1 || onlySelectOne }"
                  >
                    <span class="hmicon icon-jianhao"></span>
                  </div>
                  <div>
                    <input
                      :class="{ isDisabled: isPreview }"
                      type="number"
                      v-model="v.num"
                      :disabled="isPreview"
                      :min="1"
                      :max="v.fetchLimitNum"
                      :readonly="onlySelectOne"
                      @blur="numberBlur(v)"
                    />
                    <!-- <input @mousewheel.prevent.native
                         :class="{isDisabled: isPreview}"
                         type="number"
                         v-model="v.num"
                         :disabled="isPreview"
                    min="1">-->
                  </div>
                  <div
                    class="plus"
                    @click="toPlus(i, v.num >= v.fetchLimitNum, isEnableButton)"
                    v-show="!isPreview"
                    :class="{
                      disabled:
                        (!isEnableButton && v.num >= v.fetchLimitNum) ||
                        onlySelectOne
                    }"
                  >
                    <span class="hmicon icon-jiahao"></span>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="transferMode === 'sendTarget'">
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper flex"
              >
                <el-checkbox :label="v" class="devide-body">
                  <span class="flex-1">{{ v.outletName || v.departName }}</span>
                  <span class="flex-2">{{
                    v.name || v.realName || v.realname
                  }}</span>
                  <span class="flex-1">{{ v.workNum }}</span>
                </el-checkbox>
              </div>
            </template>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div
      v-show="
        !notValid && rightChecked.length <= 0 && transferMode === 'selectRule'
      "
      class="error"
    >
      请选择使用规则
    </div>
    <div
      v-show="
        !notValid && rightChecked.length <= 0 && transferMode === 'bindGuider'
      "
      class="error"
    >
      请绑定导购
    </div>
    <div
      v-show="
        !notValid && rightChecked.length <= 0 && transferMode === 'filterGuider'
      "
      class="error"
    >
      请绑定导购
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    background: { type: String },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    transferMode: { type: String },
    isPreview: { type: Boolean },
    notValid: { type: Boolean },
    onlySelectOne: { type: Boolean },
    eventType: { type: String }
  },
  data() {
    return {
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: ""
    };
  },
  computed: mapState({
    isEnableButton: state => state.rules.isEnableButton
  }),
  watch: {
    eventType(val) {
      if (val === "wxCardSend") {
        this.rightData = [];
      }
    },
    leftOption(val) {
      this.leftData = val;
    },
    rightChecked(val) {
      if (this.rightName === "给下列导购发放优惠券") {
        this.$store.commit("queryIsEnable", val.length > 0);
      }
    }
  },
  methods: {
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.leftData.length > 0) {
          this.rightData = this.rightData.concat(this.leftData);
          this.leftData = [];
          this.leftChecked = [];
        }
        this.handleRightCheckAllChange(true);
        this.leftCheckAll = false;
        this.rightCheckAll = true;
      }
    },
    toRight() {
      // 移动选中到右边
      const result = this.checkCommon(this.leftChecked, this.rightData);
      console.log(result)
      console.log(this.leftChecked)
      console.log(this.rightData)
      if (!result) {
        this.rightData = this.rightData.concat(this.leftChecked);
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (
              this.transferMode === "bindGuider" ||
              this.transferMode === "sendTarget"
            ) {
              if (v.objectId === this.leftChecked[0].objectId) {
                this.leftData.splice(i, 1);
              }
            } else {
              if (v.ruleId === this.leftChecked[0].ruleId) {
                this.leftData.splice(i, 1);
              }
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (
                this.transferMode === "bindGuider" ||
                this.transferMode === "sendTarget"
              ) {
                if (v.objectId === item.objectId) {
                  this.leftData.splice(index, 1);
                }
              } else {
                if (v.ruleId === item.ruleId) {
                  this.leftData.splice(index, 1);
                }
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      console.log("2~")
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);
      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (
              this.transferMode === "bindGuider" ||
              this.transferMode === "sendTarget"
            ) {
              if (v.objectId === this.rightChecked[0].objectId) {
                this.rightData.splice(i, 1);
              }
            } else {
              if (v.ruleId === this.rightChecked[0].ruleId) {
                this.rightData.splice(i, 1);
              }
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (
                this.transferMode === "bindGuider" ||
                this.transferMode === "sendTarget"
              ) {
                if (v.objectId === item.objectId) {
                  this.rightData.splice(index, 1);
                }
              } else {
                if (v.ruleId === item.ruleId) {
                  this.rightData.splice(index, 1);
                }
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toMinus(i, disabled) {
      // 减少数量
      if (!disabled && !this.onlySelectOne) {
        this.rightData[i].num--;
      }
    },
    toPlus(i, disabled, isEnableButton) {
      // 增加数量
      console.log("isEnableButton:",isEnableButton);
      if ((isEnableButton || !disabled) && !this.onlySelectOne) {
        this.rightData[i].num++;
      }
    },
    numberBlur(v){
      let msg;
      if (v.num >=1 && v.num <=v.fetchLimitNum && (/(^[1-9]\d*$)/.test(v.num))) {
        console.log("this.rightData[i].num");
      }else{
        if(v.fetchLimitNum>1){
          msg = "请输入1到"+ v.fetchLimitNum +"之间的整数";
        }else{
          msg = "请输入整数1";
        }
        this.$message({
          message: msg,
          type: "warning"
        });
        v.num = 1;
        return false;
      }
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (
            this.transferMode === "bindGuider" ||
            this.transferMode === "sendTarget"
          ) {
            if (v.objectId === item.objectId) {
              this.$message({
                message: "请不要移动重复项",
                type: "warning"
              });
              result = true;
            }
          } else {
            if (v.ruleId === item.ruleId) {
              this.$message({
                message: "请不要移动重复项",
                type: "warning"
              });
              result = true;
            }
          }
        });
      });
      return result;
    }
  }
};
</script>
<style lang="scss">
.devide-body {
  .el-checkbox__label {
    display: flex;
    align-items: center;
    flex: 1;
  }
}
</style>
<style lang="scss" scoped>
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  height: 2rem;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
</style>
